import { AppBar, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  padding: "1rem",
  overflow: "auto", // Enable scrolling for long content
  flexGrow: 1,
  "&::-webkit-scrollbar": {
    display: "none", // Hide scrollbar in Webkit browsers
  },
  "-ms-overflow-style": "none", // Hide scrollbar in IE/Edge
  "scrollbar-width": "none", // Hide scrollbar in Firefox
});

export const AppBarStyled = styled(AppBar)({
  backgroundColor: "#021526",
  zIndex: 1300,
});
